import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/cash_register_services?include=service`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/cash_register_services/${id}?include=service`, options)
        .then(response => {
            let deviceFirmwareVersion = jsona.deserialize(response.data);
            delete deviceFirmwareVersion.links;
            return deviceFirmwareVersion;
        });
}

function add(deviceFirmwareVersion) {
    const payload = jsona.serialize({
        stuff: deviceFirmwareVersion,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/cash_register_services`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function multipleAdd(deviceFirmwareVersion) {
    // const payload = jsona.serialize({
    //     stuff: deviceFirmwareVersion,
    //     includeNames: null
    // });
    const payload = deviceFirmwareVersion;

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/cash_register_services/multiple-add`, payload, options)
        .then(response => {
            return response.data;
        });
}

function update(deviceFirmwareVersion) {
    const payload = jsona.serialize({
        stuff: deviceFirmwareVersion,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/cash_register_services/${deviceFirmwareVersion.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/cash_register_services/${id}`, options);
}

export default {
    list,
    get,
    add,
    multipleAdd,
    update,
    destroy
};